.pes-software-modal-header-row {
  border-bottom: 1px solid #e7e6e6;
  margin-bottom: 14px;
  padding-bottom: 10px;
}

@media screen and (min-width: 980px) {
  .pes-software-modal-header-row {
    display: grid;
    grid-template-columns: 3fr 2fr 1fr 1fr 1fr 1fr 0.5fr 0.5fr;
    margin-bottom: 0;
  }
}